
import listing_contract_button from "./listing_contact_button/track"
import nav_related from "./navbar_related/onLoad"

const onLoad = () => {
  listing_contract_button.track()
  nav_related.onLoad()
}

export default {onLoad}
